//import Container from "react-bootstrap/Container";
import logo from './logo.svg';
//import './App.css';
import './cstyles.css'
import {useAuth} from './lib/StAuthGiver';
import {getTrackingData} from './lib/Common_funcs';
import { useNavigate } from "react-router-dom";
import StDashTopbar from './components/StDashTopbar.js';
import StDashSidebar from './components/StDashSidebar.js';
import StDashLanding from "./pages/StDashLanding.js";
import StDashSite from "./pages/StDashSite.js";
import StDashContactForms from "./pages/StDashContactForms.js";
import StAuthKeys from "./pages/StAuthKeys.js";
import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Alert, Card } from 'react-bootstrap';

// Environment configuration
const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined?'aws':'staging');
const Tdebug = (WhichEnv != 'aws');

// API server selection
const getApiServer = () => {
  if (WhichEnv === 'aws') {
      return 'https://api-us.turbosteed.com';
  }
  else {
      return `https://${process.env.REACT_APP_HOST_URL}`;
  }   
}

function Onboard({ onComplete }) {
  // State management for form data
  const [userInfo, setUserInfo] = useState({
    fullName: '',
    role: '',
    source: '',
    useCase: '',
    acceptTerms: false
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
	const [utm, setUtm] = useState(getTrackingData());
  
  // Hooks for authentication and navigation
  const {loginAction} = useAuth();
  const navigate = useNavigate();

  // Effect to disable scrolling and add Poppins font
  useEffect(() => {
    // Add Google Fonts Poppins to head
    if (!document.querySelector('link[href*="Poppins"]')) {
      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    
    // Apply Poppins font to body
    document.body.style.fontFamily = "'Poppins', sans-serif";
    
    // Completely disable scrolling on all elements
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100vh';
    
    return () => {
      // Re-enable scrolling when component unmounts
      document.body.style.overflow = 'auto';
      document.body.style.height = 'auto';
      document.documentElement.style.overflow = 'auto';
      document.documentElement.style.height = 'auto';
    };
  }, []);

  // Handle form input changes
  const handleChange = (e) => {
    Tdebug && console.log(e.target.value);
    Tdebug && console.log(e.target.name);
    
    if (e.target.name == 'acceptTerms') {
      setUserInfo({ ...userInfo, ['acceptTerms']: !userInfo['acceptTerms'] });
    }
    else {
      setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    
    // Get stored account credentials
    const acctSid = localStorage.getItem('turbosteedAcct');
    const act_e = localStorage.getItem('act_e');
    Tdebug && console.log(userInfo);
    
    try {
      // Submit onboarding data to API
      const response = await fetch(getApiServer() + '/users/' + acctSid + '/onboard', {
        method: 'POST',
        withCredentials: 'true',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)
        },
        body: JSON.stringify({
          'onboarding': {
            'name': userInfo.fullName,
            'role': userInfo.role,
            'source': userInfo.source,
            'useCase': userInfo.useCase,
            'acceptTerms': userInfo.acceptTerms,
            'utm': utm
          }
        })
      });
      
      if (!response.ok) {
        throw new Error('Failed to onboard user');
      }
      
      const responseJson = await response.json();
      Tdebug && console.log(responseJson);
      
      // Handle authentication token
      if ((responseJson.etac !== undefined) && (responseJson.etac !== null)) {
        let encAuth = responseJson.etac;
        loginAction(null, encAuth);
      }
      
      // Handle site creation response
      if (responseJson.siteId) {
        let sites = [{
          "siteId": responseJson.siteId, 
          "siteName": responseJson.siteName
        }];
        localStorage.setItem("sites", JSON.stringify(sites));
        localStorage.setItem("curSiteIdx",0);
        setSuccess(true);
        
        // Navigate to dashboard after delay
        setTimeout(() => {
          navigate('/' + sites[0].siteId + '/home', {replace: true});
        }, 1500);
      } else {
        setError("Unable to create your account. Please try again.");
      }
    } catch (error) {
      Tdebug && console.log(error);
      setError("Something went wrong. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center bg-light overflow-hidden">
      <Container fluid className="h-100 overflow-hidden">
        <Row className="justify-content-center align-items-center h-100">
          {/* Responsive column sizing - narrower card */}
          <Col xs={11} sm={9} md={7} lg={5} xl={4} xxl={3} className="h-100 d-flex align-items-center">
            <Card className="border-0 shadow-lg rounded-4 w-100 overflow-hidden" 
                  style={{maxHeight: '92vh', maxWidth: '400px'}} >
              
              <Card.Header className="bg-white border-0 text-center py-2 px-3">
                
                <div className="d-inline-flex align-items-center justify-content-center rounded-2 ">
                      <img src="/horse-log.png" className='rounded' alt="" width={'auto'} height={'50px'} />
                </div>
                
                <Card.Title className="mb-1 fw-medium text-dark" style={{fontSize: '1rem'}}>
                  Welcome to TurboSteed
                </Card.Title>
                <Card.Text className="text-muted mb-0 fw-light" style={{fontSize: '0.7rem'}}>
                  Let's get your account set up in just a few steps
                </Card.Text>
              </Card.Header>

              <Card.Body className="px-3 py-2 overflow-hidden">
                {error && (
                  <Alert variant="danger" className="border-0 rounded-2 mb-2 shadow-sm py-1">
                    <div className="d-flex align-items-center">
                      <span className="fw-normal" style={{fontSize: '0.75rem'}}>{error}</span>
                    </div>
                  </Alert>
                )}
                {success && (
                  <Alert variant="success" className="border-0 rounded-2 mb-2 shadow-sm py-1">
                    <div className="d-flex align-items-center">
                      <span className="fw-normal" style={{fontSize: '0.75rem'}}>Account created successfully! Redirecting...</span>
                    </div>
                  </Alert>
                )}

                <Form onSubmit={handleSubmit} className="overflow-hidden">
                  
                  <Form.Group className="mb-2">
                    <Form.Label className="fw-normal text-dark mb-1 text-uppercase" style={{fontSize: '0.65rem', letterSpacing: '0.5px'}}>
                      Full Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="fullName"
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                      className="border-2 rounded-2 shadow-sm form-control-sm"
                      style={{
                        borderColor: '#e9ecef', 
                        fontSize: '0.8rem',
                        fontWeight: '400',
                        transition: 'all 0.2s ease'
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2 position-relative">
                    <Form.Label className="fw-normal text-dark mb-1 text-uppercase" style={{fontSize: '0.65rem', letterSpacing: '0.5px'}}>
                      What's your role?
                    </Form.Label>
                    <Form.Select
                      name="role"
                      onChange={handleChange}
                      required
                      className="border-2 rounded-2 shadow-sm form-select-sm"
                      style={{
                        borderColor: '#e9ecef', 
                        fontSize: '0.8rem',
                        fontWeight: '400',
                        paddingRight: '2.5rem',
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23495057' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 0.75rem center',
                        backgroundSize: '16px 12px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <option value="" style={{fontSize: '0.8rem', fontWeight: '400'}}>Select your role</option>
                      <option value="Developer" style={{fontSize: '0.8rem', fontWeight: '400'}}>Developer</option>
                      <option value="Designer" style={{fontSize: '0.8rem', fontWeight: '400'}}>Designer</option>
                      <option value="Entrepreneur" style={{fontSize: '0.8rem', fontWeight: '400'}}>Entrepreneur</option>
                      <option value="Student" style={{fontSize: '0.8rem', fontWeight: '400'}}>Student</option>
                      <option value="Freelancer" style={{fontSize: '0.8rem', fontWeight: '400'}}>Freelancer</option>
                      <option value="Other" style={{fontSize: '0.8rem', fontWeight: '400'}}>Other</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2 position-relative">
                    <Form.Label className="fw-normal text-dark mb-1 text-uppercase" style={{fontSize: '0.65rem', letterSpacing: '0.5px'}}>
                      What will you use TurboSteed for?
                    </Form.Label>
                    <Form.Select
                      name="useCase"
                      onChange={handleChange}
                      required
                      className="border-2 rounded-2 shadow-sm form-select-sm"
                      style={{
                        borderColor: '#e9ecef', 
                        fontSize: '0.8rem',
                        fontWeight: '400',
                        paddingRight: '2.5rem',
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23495057' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 0.75rem center',
                        backgroundSize: '16px 12px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <option value="" style={{fontSize: '0.8rem', fontWeight: '400'}}>Select use case</option>
                      <option value="PersonalWebsite" style={{fontSize: '0.8rem', fontWeight: '400'}}>Personal website</option>
                      <option value="BusinessWebsite" style={{fontSize: '0.8rem', fontWeight: '400'}}>Business website</option>
                      <option value="ClientProjects" style={{fontSize: '0.8rem', fontWeight: '400'}}>Client projects</option>
                      <option value="POC" style={{fontSize: '0.8rem', fontWeight: '400'}}>Proof of concepts</option>
                      <option value="Other" style={{fontSize: '0.8rem', fontWeight: '400'}}>Other</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2 position-relative">
                    <Form.Label className="fw-normal text-dark mb-1 text-uppercase" style={{fontSize: '0.65rem', letterSpacing: '0.5px'}}>
                      How did you hear about us?
                    </Form.Label>
                    <Form.Select
                      name="source"
                      onChange={handleChange}
                      required
                      className="border-2 rounded-2 shadow-sm form-select-sm"
                      style={{
                        borderColor: '#e9ecef', 
                        fontSize: '0.8rem',
                        fontWeight: '400',
                        paddingRight: '2.5rem',
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23495057' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 7 7 7-7'/%3e%3c/svg%3e")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 0.75rem center',
                        backgroundSize: '16px 12px',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <option value="" style={{fontSize: '0.8rem', fontWeight: '400'}}>Select source</option>
                      <option value="Google" style={{fontSize: '0.8rem', fontWeight: '400'}}>Google / Search engines</option>
                      <option value="Friend" style={{fontSize: '0.8rem', fontWeight: '400'}}>Friend recommendation</option>
                      <option value="Social Media" style={{fontSize: '0.8rem', fontWeight: '400'}}>Social Media</option>
                      <option value="Other" style={{fontSize: '0.8rem', fontWeight: '400'}}>Other</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Check 
                      type="checkbox"
                      name="acceptTerms"
                      onChange={handleChange}
                      required
                      id="acceptTerms"
                      className="form-check-sm"
                      label={
                        <span className="text-muted fw-light" style={{fontSize: '0.7rem', lineHeight: '1.2'}}>
                          I agree to TurboSteed's{' '}
                          <a 
                            href="https://www.turbosteed.com/terms.html" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-primary text-decoration-none fw-normal"
                          >
                            Terms of Service
                          </a>
                          {' '}and{' '}
                          <a 
                            href="https://www.turbosteed.com/privacy.html" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-primary text-decoration-none fw-normal"
                          >
                            Privacy Policy
                          </a>
                        </span>
                      }
                    />
                  </Form.Group>
                  <div className="d-grid gap-1 mt-3">
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={loading}
                      className="fw-normal border-0 rounded-2 shadow btn-sm"
                      style={{fontSize: '0.85rem', padding: '7px 0', fontWeight: '500'}}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                          Creating Account...
                        </>
                      ) : (
                        'Get Started'
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Onboard;
